import React from 'react';
import SoldMembershipsContainer from './SoldMembershipsContainer';

const SoldMemberships: React.FC = () => {
    return <SoldMembershipsContainer />;
};

export default SoldMemberships;
